<div
  class="d-flex flex-column w-100 h-100"
  *ngIf="areMultipleAccountsSelected$ | async; else singleAccountSelected"
>
  <hs-panel-card header="Multiple Accounts Selected">
    <p>
      This panel requires a single account to be selected before information can
      be displayed. Select a single account from the Accounts panel to continue.
    </p>
  </hs-panel-card>
</div>

<ng-template #singleAccountSelected>
  <div
    *ngIf="isSingleAccountSelected$ | async; else noAccountSelected"
    class="d-flex flex-column w-100 h-100"
  >
    <!--https://medium.com/@pietmichal/angulars-content-projection-trap-and-why-you-should-consider-using-template-outlet-instead-cc3c4cad87c9-->
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </div>
</ng-template>

<ng-template #noAccountSelected>
  <div class="d-flex flex-column w-100 h-100">
    <hs-panel-card header="No Account Selected">
      <p>
        This panel requires an account to be selected before information can be
        displayed. Select an account from the Accounts panel to continue.
      </p>
    </hs-panel-card>
  </div>
</ng-template>
